<template>
  <section class="content">
   <div id="overlay"  v-if="loading">
     <div class="spinner"></div>
     <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <label for="purchaseSalesDate">Consumption Date</label>
                  <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                  <input-mask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
                </div>

              <div class="p-field p-col-12 p-md-2">
                <label for="consumptionNo">Consumption No</label>
                <InputText id="consumptionNo" disabled v-model="consumptionNo"/>
              </div>
             <div class="p-field p-col-12 p-md-2">
               <label for="referenceNumber" >Ref No</label>
               <InputText id="refNO"  v-model="referenceNumber"/>
             </div>

              <div class="p-field p-col-12 p-md-2">
               <label for="warehouse">Store</label>
                <Dropdown
                 v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                 v-if="setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
              </div>
              <wearhouseDialog class="p-mt-5" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <!-- <div class="form-group container">
              <div class="col-md-3">
               <label for="party">Order From</label>
                <Dropdown
                  v-model="accountMasterId"
                  :options="supplierAndCustomerList"
                  optionLabel="name"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select Vendor"
                  :showClear="true"
                />
                 <customerDialog style="float: left;margin: -12.5% 0% 0% 93%;" v-tooltip.top="'Add Customer'"/>
              </div>
              <div class="col-md-3 " style="margin-top: 2.5em;" v-if="accountMasterId.id>0">
               <label for="panNo" >Cur. Bal:</label>
               <b  style="margin-left:20px;color:red" v-if="accountMasterId.closingBalance>0">{{(accountMasterId.closingBalance) + 'Cr'}}</b>
               <b v-else style="margin-left:20px;color:green;">{{(accountMasterId.closingBalance * (-1)).toFixed(2) + 'Dr'}}</b>
             </div>
              <div class="col-md-2 address" style="margin-top: 2.5em;">
                <label for="address" v-if="accountMasterId.id>0">Contact Name:</label>
                <b>{{accountMasterId.contactName}}</b>
              </div>
              <div class="col-md-2 address" style="margin-top: 2.5em;" v-if="accountMasterId.id>0">
                <label for="panNo"  v-if="accountMasterId.id>0">Pan No:</label>
                <b>{{accountMasterId.panNo!==''?accountMasterId.panNo:'N/A'}}</b>
              </div>
            </div> -->

            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                <label for="item" >Item<b style="color:red;">*</b></label>
                <!-- <Dropdown
                  v-model="items"
                  :options="itemMasterListByItemType"
                  optionLabel="name"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select Item"
                /> -->
                <AutoComplete v-model="items" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                 field="name" ref="itm" >
                  <template #item="slotProps">
                    <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
                  </template>
                 </AutoComplete>
              </div>
              <div class="p-field p-col-12 p-md-1 align-self-end">
            <itemDialog class="p-mt-5" v-tooltip.top="'Add Item'"
                      @set_data_item="set_data_item"/>
          </div>
              <!-- <itemDialog style="margin-top:1.3em;margin-right: -10em;" v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/> -->

              <div class="p-field p-col-12 p-md-2">
                <label  for="quantity">Sales Qty</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="quantity" v-model="quantity" /> -->
              <InputNumber  id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="quantity"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-1">
                <label for="qty">Unit</label>
                <InputText v-model="items.unitName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="rate">Rate</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="rate" v-model="rate" /> -->
             <InputNumber  id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="rate"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="total" >Total</label>
                <!-- <input  class="form-control" id="total" @keypress="isNumber(event)" v-model="total"/> -->
              <InputNumber disabled id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="total"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button p-component addNewBtn btn-btm-0" id="action" @click.prevent="addItemToDTO" :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button v-if="editDTO" class="p-button-raised p-button-danger" id="action"
                @click.prevent="itemDTOreset" label="Cancel"/>
              </div>
            </div>

            <div style="display:none">{{totalAmount}}{{findRate}}{{setRateFromItem}}</div>
               <div class="p-field p-col-12 p-md-2" v-if="items.closingStock >=0">
               <label  for="avlQty">Cur. Stock</label>
                <span>{{items.closingStock}}</span>
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
            <div class="scrollable">
            <table class="table table-bordered ">
              <thead >
                <tr>
                  <th scope="col">SN</th>
                  <th scope="col">Item Name</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index">
                <tr>
                  <td>{{index+1}}</td>
                  <td>{{item.itemMaster.name}}</td>
                  <td>{{item.quantity}}</td>
                  <td>{{item.rate}}</td>
                  <td>{{item.rate * item.quantity}} </td>
                  <td>
                    <Button class="p-button-raised p-button-success" icon="pi pi-pencil"
                    @click="editItemFromDTO(item, index)"/>
                    <Button class="p-button-raised p-button-danger" v-if="editDTO"
                    @click="deleteItemFromDTO(item, index)" disabled icon="pi pi-trash"/>
                    <Button icon="pi pi-trash" class="p-button-raised p-button-danger"
                    v-else-if="!editDTO" @click="deleteItemFromDTO(item, index)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
               <b style="margin-left: 15em;">Total:</b>
             </div>
            <div class="p-field p-col-12 p-md-2">
              <b style="margin-left: 16em;">{{totalQty}}</b>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <b style="margin-left: 38em;">{{subTotal}}</b>
            </div>
           </div>
          <hr>
         </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-4">
              <label >Narration</label>
              <Textarea rows="6" v-model="narration"/>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-6"></div>
              <div class="p-field p-col-12 p-md-1">
                <Button icon="pi pi-save" :label="!editing?'Save':'Update'" class="p-button-raised p-button-success"
                @click.prevent="saveSalesOrder"/>
              </div>
            <div class="p-field p-col-12 p-md-1">
              <Button label="Reset" icon="pi pi-refresh" class="p-button-raised p-button-warning"
              @click="reset"
              v-if="consumption==undefined"/>
            </div>
            <div class="p-field p-col-12 p-md-1">
              <Button type="submit" class="p-button-raised p-button-danger" v-if="consumption != undefined"
              @click="goBack()" label="Cancel"/>
              <Button type="submit" class="p-button-raised p-button-danger" v-if="consumption === undefined"
              @click="goBack()" label="Cancel" disabled/>
            </div>
            <div class="p-field p-col-12 p-md-1">
              <Button class="p-button-raised p-button-secondary" icon="pi pi-print" v-if="saved" label="Print"/>
              <Button class="p-button-raised p-button-secondary" icon="pi pi-print" v-else label="Print" disabled/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <Button class="p-button-raised p-button-secondary" icon="pi pi-download" label="Generate PDF" v-if="saved"/>
              <Button class="p-button-raised p-button-secondary" icon="pi pi-download" label="Generate PDF" v-else disabled/>
            </div>
        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import customerDialog from '../accountDialog/CustomerAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import InputText from 'primevue/inputtext'
export default {
  name: 'consumption',
  props: ['consumption'],
  data() {
    return {
      warehouseId: '',
      accountMasterId: '',
      items: '',
      referenceNumber: '',
      englishDateEnabled: true,
      quantity: 0,
      orderMessage: '',
      rate: 0,
      purchaseSalesDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      editDTO: false,
      editing: false,
      inventoryOutheaderId: null,
      index: null,
      consumptionNo: null,
      loading: false,
      id: null,
      totalQty: '',
      total: 0,
      filteredItems: null,
      saved: false,
      narration: '',
      setWarehouseData: false
    }
  },
  computed: {
    totalBillAmount() {
      return parseFloat(this.quantity) * parseFloat(this.rate)
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    findRate() {
      if (this.total > 0 && this.quantity > 0) {
        let rate = 0
        rate = parseFloat(this.total) / parseFloat(this.quantity)
        if (isNaN(rate)) {
          rate = 0
        }
        this.rate = rate
        return rate
      }
    },
    setRateFromItem() {
      if (!this.editDTO) {
        let rate = 0
        this.rate = this.items.salesRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return subTotal.toFixed(4)
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierAndCustomerList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerList()
    this.itemMasterListByItemTypes()
    this.maxSalesOrderNo()
    if (this.consumption !== undefined) {
      this.editSales()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.consumption === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierAndCustomerList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemType')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      }
    },
    async maxSalesOrderNo() {
      let response = await this.$store.dispatch('maxConsumptionNo')
      if (this.consumption === undefined) {
        this.consumptionNo = response.data.data
        this.orderMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.consumptionNo = this.consumption.consumptionNo
        this.orderMessage = this.consumption.remarks
      }
    },
    addItemToDTO() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
    //   if (this.accountMasterId === '') {
    //     this.$toast.add({severity: 'error', summary: '', detail: 'Please select sale to!', life: 10000})
    //     return
    //   }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one Item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editItemFromDTO(data, index) {
      this.itemDTOreset()
      this.editDTO = true
      this.items = data.itemMaster
      this.index = index
      this.total = (parseFloat(this.rate) * parseFloat(this.quantity)).toFixed(2)
      this.rate = data.rate
      this.quantity = data.quantity
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    async saveSalesOrder() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      let response = ''
      let consumption = {
        consumptionNo: this.consumptionNo,
        warehouseId: this.warehouseId.id,
        accountMasterId: this.accountMasterId.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        remarks: this.narration,
        id: this.inventoryOutheaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList
      }
      // console.log
      // // debugger
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
    //   if (this.accountMasterId === '') {
    //     this.$toast.add({severity: 'error', summary: '', detail: 'Please select sale to!', life: 10000})
    //     return
    //   }
      if (consumption.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please add at least one item!', life: 10000})
        return
      }
      if (this.consumption === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addConsumption', consumption)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateConsumption', consumption)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.setWarehouse()
        await this.maxSalesOrderNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    set_data_warehouse(data) {
      this.warehouseId = data
    },
    set_data_item(data) {
      this.items = data
    },
    editSales() {
      this.editing = true
      // this.purchaseSalesDate = this.salesOrder.purchaseSalesDate
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.consumption.purchaseSalesDateNepali
        // this.shipDate = this.salesOrder.shipDateNepali
        // // debugger
      } else {
        this.purchaseSalesDate = this.consumption.purchaseSalesDate
        // this.shipDate = this.salesOrder.shipDate
      }
      this.referenceNumber = this.consumption.referenceNumber
      this.narration = this.consumption.remarks
      this.warehouseId = this.consumption.warehouse
      this.accountMasterId = this.consumption.accountMaster
      this.inventoryOutheaderId = this.consumption.id
      this.inventoryInOutDetailList = this.consumption.inventoryInOutDetailList
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    setNepaliDate() {
      if (this.consumption === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        // this.shipDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      // this.shipDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouseId = ''
      this.accountMasterId = ''
      this.referenceNumber = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.inventoryInOutDetailList = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.consumption.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    customerDialog,
    wearhouseDialog,
    itemDialog,
    Button,
    Textarea,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// consumption.vue?5b2fbddb